/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import { COLORS } from "./categories.constants";

export default function CategoryCard({ icon, name }) {
  return (
    <div
      className="category-card"
      style={{
        flexShrink: 0,
        width: "200px",
        padding: "30px 20px",
        borderRadius: 18,
        background: "rgba(255,255,255,0.08)",
        border: `1.5px solid rgba(255,255,255,0.15)`,
        color: COLORS.textLight,
        transition: "all 0.3s ease",
        cursor: "pointer",
        boxShadow: "0 5px 15px rgba(0,0,0,0.25)",
        backdropFilter: "blur(8px)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        userSelect: "none",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-8px) scale(1.05)";
        e.currentTarget.style.boxShadow =
          "0 12px 30px rgba(242,180,65,0.3)";
        e.currentTarget.style.background = "rgba(255,255,255,0.15)";
        e.currentTarget.style.border = `1.5px solid ${COLORS.gold}`;
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0) scale(1)";
        e.currentTarget.style.boxShadow = "0 5px 15px rgba(0,0,0,0.25)";
        e.currentTarget.style.background = "rgba(255,255,255,0.08)";
        e.currentTarget.style.border = `1.5px solid rgba(255,255,255,0.15)`;
      }}
    >
      <div style={{ fontSize: "3rem", marginBottom: 12 }}>{icon}</div>

      <div
        className="fw-semibold"
        style={{
          color: COLORS.gold,
          fontSize: "1.05rem",
          fontFamily: "'Cairo', sans-serif",
          whiteSpace: "nowrap",
          lineHeight: "1.4",
        }}
      >
        {name}
      </div>
    </div>
  );
}
